import { PROPERTY_PURPOSE } from "properties/_models/PropertyMdl";
import { PropertiesStore } from "properties/_stores/propertiesStore";

const propertiesBuyingStore = new PropertiesStore(PROPERTY_PURPOSE.BUY);
export { propertiesBuyingStore };
